import { render } from "./PostControlSection.vue?vue&type=template&id=16f2b6b9&scoped=true"
import script from "./PostControlSection.vue?vue&type=script&lang=js"
export * from "./PostControlSection.vue?vue&type=script&lang=js"

import "@/assets/widget.css?vue&type=style&index=0&id=16f2b6b9&scoped=true&lang=css&external"
import "./PostControlSection.vue?vue&type=style&index=1&id=16f2b6b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f2b6b9"]])

export default __exports__